import { atom } from 'jotai';
import ErrorRetryModal from 'src/components/ErrorRetryModal';
import { showModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
export const showNetworkErrorReloadModalAtom = atom(null, (get, set) => {
  set(showModalAtom, {
    key: ModalType.NETWORK_ERROR_RELOAD,
    component: () => <ErrorRetryModal title='common__problem_occurred' description='COMMON__INTERNET_RECONNECT' onRetry={() => {
      window.location.reload();
    }} />
  });
});